import { useEffect, type ReactNode } from 'react';
import { Spinner } from '@yhelp/ui';
import { AuthLayout } from '@/templates/AuthLayout';
import { useLogin } from '@/auth/login';

export function AuthGuard({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading, login } = useLogin();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      void login(window.location.pathname).catch((err: unknown) => {
        console.error('[yhelp] AuthGuard login redirect failed', err);
      });
    }
  }, [isAuthenticated, isLoading, login]);

  if (isLoading || !isAuthenticated) {
    return (
      <AuthLayout title="Autenticando" subtitle="Aguarde enquanto validamos sua sessão">
        <div className="flex justify-center py-8">
          <Spinner size="lg" label="Carregando…" />
        </div>
      </AuthLayout>
    );
  }

  return children;
}
